module.exports = __webpack_public_path__ + "fonts/Roboto-Light.ea36cd9a.woff";